<template>
  <iSelect
    v-if="presentation === 'dropdown'"
    v-model="value"
    :items="selectItems"
    value-field="value"
    return-value
    width="fill"
    display-caret-icon
  />
  <iRadioBar
    v-else-if="presentation === 'segmented' || presentation === 'chips'"
    v-model="value"
    :options="radioBarOptions"
    :max-items-per-row="presentation === 'chips' ? -1 : enumOptions.length"
  />
  <iColumn v-else gap="extraSmall" width="fill">
    <iRadioButton
      v-for="option in enumOptions"
      :key="option"
      v-model="value"
      :value="option"
      :label="option"
      :name="radioGroupName"
    />
  </iColumn>
</template>

<script>
import { DynamicElementMixin } from "%/dynamic-components/render-engine/mixins/production/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-components/render-engine/mixins/production/dynamic-element-with-context-mixin";
import EnumInputPresentation from "%/dynamic-components/render-engine/options/enum-input-presentation";

export default {
  name: "DynamicAppEnumInputElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext],
  elementPanelSettings: {
    displayName: "Option Picker",
    elementGroup: "general",
    displayIcon: "list",
    elementType: "element",
  },
  hidden: true,
  options: [
    EnumInputPresentation,
  ],
  computed: {
    presentation() {
      return this.getOptionValue(EnumInputPresentation) ?? EnumInputPresentation.defaultValue;
    },
    enumOptions() {
      const field = this.relatedEntity?.fields?.[this.elementContext.field];
      return Array.isArray(field?.enumOptions) ? field.enumOptions : [];
    },
    selectItems() {
      return this.enumOptions.map(option => ({ name: option, value: option }));
    },
    radioBarOptions() {
      return this.enumOptions.map(option => ({ value: option, label: option }));
    },
    radioGroupName() {
      return `${this.elementContext.entityContext}-${this.elementContext.field}`;
    },
    value: {
      get() {
        return this.valueFromContext;
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = value;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
